import React, { useEffect, useRef } from 'react';

const HexagonBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let startTime = Date.now();

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    window.addEventListener('resize', resize);
    resize();

    const drawHexagon = (x, y, size) => {
      ctx.beginPath();
      for (let i = 0; i < 6; i++) {
        const angle = (60 * i - 30) * Math.PI / 180;
        const px = x + size * Math.cos(angle);
        const py = y + size * Math.sin(angle);
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      }
      ctx.closePath();
      ctx.stroke();
    };

    const render = () => {
      const t = (Date.now() - startTime) / 1000;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 1. Solid Deep Background
      ctx.fillStyle = '#030308';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 2. Animated Hexagon Pattern (Only pulsing light)
      const hexSize = 25; // Smaller hexagons for more density
      const width = Math.sqrt(3) * hexSize;
      const height = 2 * hexSize;
      const xDist = width;
      const yDist = (3 / 4) * height;

      const rows = Math.ceil(canvas.height / yDist) + 2;
      const cols = Math.ceil(canvas.width / xDist) + 2;

      ctx.lineWidth = 0.6; // Thinner lines for elegance

      for (let row = -1; row < rows; row++) {
        for (let col = -1; col < cols; col++) {
          let x = col * xDist;
          let y = row * yDist;

          if (row % 2 !== 0) {
            x += xDist / 2;
          }

          const dx = x - canvas.width / 2;
          const dy = y - canvas.height / 2;
          const dist = Math.sqrt(dx * dx + dy * dy);

          // Wave pulse logic - Faster and smoother
          const wave = Math.sin(dist * 0.015 - t * 2.0);
          const opacity = 0.05 + 0.3 * Math.pow((0.5 + 0.5 * wave), 4); // Increased opacity for better visibility

          ctx.strokeStyle = `rgba(0, 242, 255, ${opacity})`;
          drawHexagon(x, y, hexSize);
        }
      }

      animationFrameId = requestAnimationFrame(render);
    };

    render();

    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        pointerEvents: 'none',
      }}
    />
  );
};

export default HexagonBackground;
